import { SVGProps } from "react"
const Home2Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.66797 18.334H18.3346"
      stroke={props.color || "#292D32"}
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.45703 18.3324L2.4987 8.30739C2.4987 7.79905 2.74036 7.31577 3.14036 6.9991L8.9737 2.45742C9.5737 1.99076 10.4154 1.99076 11.0237 2.45742L16.857 6.99076C17.2654 7.30742 17.4987 7.79072 17.4987 8.30739V18.3324"
      stroke={props.color || "#292D32"}
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
    <path
      d="M10.8346 14.166H9.16797C8.4763 14.166 7.91797 14.7243 7.91797 15.416V18.3327H12.0846V15.416C12.0846 14.7243 11.5263 14.166 10.8346 14.166Z"
      stroke={props.color || "#292D32"}
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
    <path
      d="M7.91797 11.4577H6.2513C5.79297 11.4577 5.41797 11.0827 5.41797 10.6243V9.37435C5.41797 8.91602 5.79297 8.54102 6.2513 8.54102H7.91797C8.3763 8.54102 8.7513 8.91602 8.7513 9.37435V10.6243C8.7513 11.0827 8.3763 11.4577 7.91797 11.4577Z"
      stroke={props.color || "#292D32"}
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
    <path
      d="M13.75 11.4577H12.0833C11.625 11.4577 11.25 11.0827 11.25 10.6243V9.37435C11.25 8.91602 11.625 8.54102 12.0833 8.54102H13.75C14.2083 8.54102 14.5833 8.91602 14.5833 9.37435V10.6243C14.5833 11.0827 14.2083 11.4577 13.75 11.4577Z"
      stroke={props.color || "#292D32"}
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
    <path
      d="M15.8323 5.83398L15.8073 3.33398H12.1406"
      stroke={props.color || "#292D32"}
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default Home2Icon
